module.exports = __webpack_public_path__ + "img/header_bg.cc70f33b.png";